import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Descriptions, Divider, Row, Col, Image, Space, Typography, Avatar, Card, Tag } from 'antd'
import { UserOutlined } from '@ant-design/icons';
import ReactHtmlParser from 'react-html-parser';
import { isMobile } from 'react-device-detect';
import { isValidDate, renderBooleanIcon } from '@/utils/helpers';
import CreatedAtCell from '@/components/CreatedAtCell';

const { Text } = Typography;

class UserDetail extends Component {

    handleCancel() {
        this.props.onCancel();
    }

    renderFileGroup = (files = []) => {
        if (!Array.isArray(files) || files.length === 0) {
            return <Text type="secondary">Không có</Text>;
        }

        return (
            <Image.PreviewGroup>
                <Space wrap>
                    {files.map((file, index) => (
                        <Image
                            key={index}
                            height={50}
                            width={50}
                            src={file.src}
                            style={{
                                border: '1px solid #dedede',
                                objectFit: 'cover',
                                objectPosition: 'center',
                            }}
                        />
                    ))}
                </Space>
            </Image.PreviewGroup>
        );
    };


    render() {
        var { visible, currentItem } = this.props;

        const item = currentItem || {};
        const temp = item.temporary_branch;

        return (
            <>
                <Drawer
                    visible={visible}
                    title={item.full_name || 'Thông tin người dùng'}
                    onClose={() => this.handleCancel()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '60%'}
                >
                    {visible ? (
                        <div>
                            <Row gutter={16}>
                                <Col xs={24} md={24} className='mb-20 pt-20' style={{ background: '#18394014', border: '1px dashed #dedede', borderRadius: '5px' }}>
                                    <Row gutter={16} justify='center'>
                                        <Col xs={24} md={24} style={{ textAlign: 'center', marginBottom: '-50px' }}>
                                            {item?.avatar_url ? (
                                                <Avatar size={150} src={item.avatar_url} />
                                            ) : (
                                                <Avatar size={150} icon={<UserOutlined />} />
                                            )}
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={24} md={24} className='mt-5'>
                                    <Row gutter={16}>
                                        <Col xs={24} md={12}>
                                            <Descriptions size="small">
                                                <Descriptions.Item label="Họ và tên">
                                                    {item.full_name}
                                                </Descriptions.Item>
                                            </Descriptions>
                                            <Divider className="no-margin" />
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Descriptions size="small">
                                                <Descriptions.Item label="Vai trò">
                                                    {item?.user_role?.name}
                                                </Descriptions.Item>
                                            </Descriptions>
                                            <Divider className="no-margin" />
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Descriptions size="small">
                                                <Descriptions.Item label="Username">
                                                    {item.username}
                                                </Descriptions.Item>
                                            </Descriptions>
                                            <Divider className="no-margin" />
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Descriptions size="small">
                                                <Descriptions.Item label="Trạng thái">
                                                    {renderBooleanIcon(item?.is_active)}
                                                </Descriptions.Item>
                                            </Descriptions>
                                            <Divider className="no-margin" />
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Descriptions size="small">
                                                <Descriptions.Item label="Trạng thái đóng bảo hiểm">
                                                    {Number(item.insurance_status) === 1
                                                        ? <Tag color="green">Có đóng bảo hiểm</Tag>
                                                        : <Tag>Không đóng bảo hiểm</Tag>}
                                                </Descriptions.Item>
                                            </Descriptions>
                                            <Divider className="no-margin" />
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Descriptions size="small">
                                                <Descriptions.Item label="E-mail">
                                                    {item.email}
                                                </Descriptions.Item>
                                            </Descriptions>
                                            <Divider className="no-margin" />
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Descriptions size="small">
                                                <Descriptions.Item label="Số điện thoại">
                                                    {item?.phone}
                                                </Descriptions.Item>
                                            </Descriptions>
                                            <Divider className="no-margin" />
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Descriptions size="small">
                                                <Descriptions.Item label="Ngày tạo">
                                                    <CreatedAtCell
                                                        createdAt={item?.created_at}
                                                        user={item?.created_user}
                                                        layout='horizontal'
                                                    />
                                                </Descriptions.Item>
                                            </Descriptions>
                                            <Divider className="no-margin" />
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Descriptions size="small">
                                                <Descriptions.Item label="Cơ sở làm việc chính">
                                                    {Array.isArray(item.primary_branches) && item.primary_branches.length > 0 ? (
                                                        item.primary_branches.map(branch => (
                                                            <Tag key={`primary-${branch.id}`} color="blue">
                                                                {branch.name}
                                                            </Tag>
                                                        ))
                                                    ) : (
                                                        <Text type="secondary">-</Text>
                                                    )}
                                                </Descriptions.Item>
                                            </Descriptions>
                                            <Divider className="no-margin" />
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Descriptions size="small">
                                                <Descriptions.Item label="Cơ sở làm việc tạm thời">
                                                    {temp?.branch ? (
                                                        <div>
                                                            <Tag color="blue">{temp.branch.name}</Tag>

                                                            <div style={{ fontStyle: 'italic' }}>
                                                                Thời gian: Từ{' '}
                                                                {temp.started_at
                                                                    ? isValidDate(temp.started_at, false)
                                                                    : '-'}
                                                                {' '}đến{' '}
                                                                {temp.ended_at
                                                                    ? isValidDate(temp.ended_at, false)
                                                                    : 'Hiện tại'}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <Text type="secondary">-</Text>
                                                    )}
                                                </Descriptions.Item>
                                            </Descriptions>
                                            <Divider className="no-margin" />
                                        </Col>
                                        <Col xs={24} md={24}>
                                            <Descriptions size="small">
                                                <Descriptions.Item label="Ghi chú">
                                                    {item.note ? ReactHtmlParser(item.note) : <Text type="secondary">-</Text>}
                                                </Descriptions.Item>
                                            </Descriptions>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Divider orientation="left" orientationMargin="0">
                                Giấy tờ liên quan
                            </Divider>
                            <Row gutter={16}>
                                <Col xs={24} md={12} className='mb-2'>
                                    <Card size="small" className='border-dashed'>
                                        <div className='mb-1 mt-1'>
                                            <Text strong>Bằng tốt nghiệp</Text>
                                        </div>
                                        {this.renderFileGroup(item.diploma_file)}
                                    </Card>
                                </Col>
                                <Col xs={24} md={12} className='mb-2'>
                                    <Card size="small" className='border-dashed'>
                                        <div className='mb-1 mt-1'>
                                            <Text strong>CCCD/CMT</Text>
                                        </div>
                                        {this.renderFileGroup(item.identity_document_file)}
                                    </Card>
                                </Col>
                                <Col xs={24} md={12} className='mb-2'>
                                    <Card size="small" className='border-dashed'>
                                        <div className='mb-1 mt-1'>
                                            <Text strong>Chứng chỉ hành nghề</Text>
                                        </div>
                                        {this.renderFileGroup(item.certificate_file)}
                                    </Card>
                                </Col>
                                <Col xs={24} md={12} className='mb-2'>
                                    <Card size="small" className='border-dashed'>
                                        <div className='mb-1 mt-1'>
                                            <Text strong>Giấy tờ khác</Text>
                                        </div>
                                        {this.renderFileGroup(item.other_documents)}
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    ) : null}
                </Drawer>
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser
    }
}

function mapDispatchToProps(dispatch) {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'UserDetail' })(UserDetail));
